<template>
  <h5 
    class="mt-2"
  >
    Deelname
  </h5>

  <div
    class="allow-reactions d-flex align-items-center justify-content-between my-2"
  >
    <p
      class="my-0"
    >
      Beperkt aantal plaatsen
    </p>

    <material-switch
      v-model="toggleHandler"
    />
  </div>

  <template
    v-if="toggleHandler"
  >
    <material-input
      v-model="inputHandler"
      label="Aantal"
      class="mb-2"
      type="number"
      min="0"
    />

    <material-input
      v-model="messageHandler"
      label="Toelichting"
      placeholder="Het is niet langer mogelijk uzelf aan te melden voor dit evenement."
    />
  </template>
</template>
  
<script>
import MaterialInput from '@/components/MaterialInput.vue';
import MaterialSwitch from '@/components/MaterialSwitch.vue';
  
export default {
  components: {
    MaterialInput,
    MaterialSwitch,
  },

  props: {
    maxAttendees: {
      type: [Number, null],
      default: null,
    },
    maxAttendeesReachedMessage: {
      type: [Number, null],
      default: null,
    }
  },

  emits: [
    'update:maxAttendees',
    'update:maxAttendeesReachedMessage'
  ],
  

  data() {
    return {
      toggleValue: this.maxAttendees != null,
      counterValue: this.maxAttendees,
      messageValue: this.maxAttendeesReachedMessage
    };
  },

  computed: {
    toggleHandler: {
      get() { return this.maxAttendees != null; },
      set(value) {
        if (value && this.maxAttendees == null) {
          this.emitAttendees(0)
          return;
        }

        this.emitAttendees(null);
      }
    },

    inputHandler: {
      get() { return this.maxAttendees ?? 0; },
      set(value) {
        if (value == '') {
          this.emitAttendees(0);
          return;
        }

        this.emitAttendees(value);
      }
    },

    messageHandler: {
      get() { return this.maxAttendeesReachedMessage; },
      set(value) {
        if (value == '') {
          this.emitMessage(null);
          return;
        }

        this.emitMessage(value);
      }
    }
  },

  methods: {
    emitAttendees(value) {
      this.$emit(
        'update:maxAttendees',
        value
      );
    },

    emitMessage(value) {
      this.$emit(
        'update:maxAttendeesReachedMessage',
        value
      );
    },

    emitState() {
      this.emitAttendees();
      this.emitMessage();
    }
  }
}
</script>